import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { Tabs } from 'components/tabs';
import { translate } from 'components/translate';
import { PAGE_VIEW_EVENTS } from 'configs/routes/constants';
import ContentBasePage from 'modules/content/components/ContentBasePage';
import MembershipService from 'modules/membership/MembershipService';
import PropTypes from 'prop-types';

import BatchImport from './BatchImport';
import HotmartImport from './HotmartImport';
import ImportHistory from './ImportHistory';
import ManuallyImport from './ManuallyImport';

const tabsIndex = {
  firstTab: 0,
  secondTab: 1
};

export const USER_IMPORT_TITLE = 'users_import.title';

@withRouter
@translate()
export default class UserImport extends Component {
  static propTypes = {
    history: PropTypes.object,
    t: PropTypes.func
  };

  state = {
    tabIndex: tabsIndex.firstTab
  };

  beforeChange = (tabIndex) => {
    this.setState({ tabIndex });
  };

  get tabs() {
    return [
      { name: this.props.t('users_import.tabs.manually') },
      { name: this.props.t('users_import.tabs.in_batch'), track: 'In batch' },
      {
        name: this.props.t('users_import.tabs.from_hotmart'),
        track: 'From Hotmart'
      },
      {
        name: this.props.t('users_import.tabs.import_history'),
        track: 'Import History'
      }
    ];
  }

  render() {
    const { history, t } = this.props;

    const actived = this.state.tabIndex;

    return (
      <ContentBasePage
        className="content__grid"
        backHandler={() =>
          history.push(MembershipService.getLink('userManager'))
        }
      >
        <ContentBasePage.Header
          title={t(USER_IMPORT_TITLE, { checkOnlineEvent: true })}
          isTitleLabel={false}
        />

        <Tabs
          track={PAGE_VIEW_EVENTS.USER.IMPORT}
          tabs={this.tabs}
          actived={actived}
          beforeTabChange={this.beforeChange}
        >
          <ManuallyImport />
          <BatchImport />
          <HotmartImport />
          <ImportHistory tabIndex={actived} />
        </Tabs>
      </ContentBasePage>
    );
  }
}
